import { onMounted, onUnmounted, ref } from 'vue'

/**
 * Whether the SupportWidget ("Need help?", bottom left) is hidden right now.
 * One flag for the whole app: the layouts render the widget, a page cannot
 * reach it, so the page flips this and the widget reads it.
 */
export const supportWidgetHidden = ref(false)

/**
 * Whether the help panel is open. Shared so the left sidebar can open it:
 * with the sidebar on, the floating pill does not show and Help lives there.
 */
export const supportWidgetOpen = ref(false)

export const openSupportWidget = () => {
  supportWidgetOpen.value = true
}

/**
 * Hides the SupportWidget while the calling page is mounted and brings it
 * back on leave. The widget sits in the bottom-left corner and covers the
 * mute / camera controls of the video call on small screens.
 */
export const useHiddenSupportWidget = () => {
  onMounted(() => {
    supportWidgetHidden.value = true
  })
  onUnmounted(() => {
    supportWidgetHidden.value = false
  })
}
